<template>
    <div>
        <Staff
            v-if="loggedIn && user.is_staff"
        />
        <Main
            v-if="loggedIn && !mobile && !user.is_staff"
        />
        <MainMobile
            v-if="loggedIn && mobile && !user.is_staff"
        />
        <UploadModal
            v-if="loggedIn && user.is_manager && !mobile"
        />
        <UploadProgressModal v-if="loggedIn && user.is_manager && !mobile" />
        <VideoEditModal
            v-if="loggedIn && user.is_manager"
        />
        <VideoLabelModal
            v-if="loggedIn && user.is_manager"
        />
        <AclModal
            v-if="loggedIn && user.is_manager && noShare"
        />
        <VideoModal v-if="loggedIn" />
        <VideoSearchModal v-if="loggedIn && !mobile" />
        <VideoSearchMobileModal v-if="loggedIn && mobile" />
        <Login v-if="!loggedIn" />
    </div>
</template>

<script>
import UploadModal from '@/components/UploadModal'
import Login from '@/components/Login'
import VideoModal from '@/components/VideoModal'
import AclModal from '@/components/AclModal'
import axios from 'axios'
import Main from '@/components/Main'
import MainMobile from '@/components/MainMobile'
import UploadProgressModal from '@/components/UploadProgressModal'
import VideoEditModal from '@/components/VideoEditModal'
import { datePicker, settings } from '@/variables'
import Staff from '@/components/Staff'
import Worker from '@/worker?worker'
import VideoLabelModal from '@/components/VideoLabelModal'
import VideoSearchModal from '@/components/VideoSearchModal'
import VideoSearchMobileModal from '@/components/VideoSearchMobileModal.vue'
import mixpanel from 'mixpanel-browser'
import { store } from '@/store.js'
import { mapState } from 'pinia'

export default {
    name: 'HomeComponent',
    components: {
        VideoSearchMobileModal,
        VideoSearchModal,
        VideoLabelModal,
        Staff,
        VideoEditModal,
        UploadProgressModal,
        Main,
        VideoModal,
        Login,
        UploadModal,
        MainMobile,
        AclModal
    },
    data () {
        return {
            evaporate: null,
            lastUpdate: Date.now(),
            datePicker,
            status: {
                init: 'アップロード待ち',
                up: 'アップロード中',
                up_end: '準備中',
                up_err: 'アップロードエラー',
                enc: '準備中',
                enc_err: '準備エラー',
                ready: '利用可能'
            },
            statusVariant: {
                init: 'light',
                up: 'primary',
                up_end: 'info',
                up_err: 'danger',
                enc: 'dark',
                enc_err: 'danger',
                ready: 'success'
            },
            teams: [],
            worker: null,
            store: store()
        }
    },
    computed: {
        ...mapState(store, ['user', 'uploadGroups', 'noShare']),
        loggedIn () {
            return !!this.user
        },
        mobile () {
            return this.$md.mobile()
        },
        phone () {
            return this.$md.phone()
        },
        deviceOs () {
            return this.$md.os()
        }
    },
    created () {
        this.worker = new Worker()
        this.worker.addEventListener('message', this.workerMethod)
        const sess = () => {
            this.$http.post('session', {
                guid: this.$guid()
            }).then((response) => {
                if (response) {
                    console.log(response)
                    this.store.setNoShare(response.data.user.group.special)
                    if (this.$ls.get('password', null) && response.data.token) {
                        this.$ls.set('token', response.data.token, 86400000)
                    }
                    /* eslint-disable no-undef */
                    gtag('set', { user_id: response.data.user.username }) // Set the user ID using signed-in user_id.
                    mixpanel.identify(response.data.user.username)
                }
            }).catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        this.$ls.remove('token')
                        this.$ls.remove('user')
                        this.store.setUser(null)
                    } else {
                        if (this.$ab) {
                            this.$ab.notify(error)
                        }
                        if (error.response.data && error.response.data.error) {
                            this.$snotify.error(error.response.data.error)
                        } else {
                            this.$snotify.error('サーバーエラー')
                        }
                    }
                } else {
                    this.$ab?.notify(error)
                }
            })
        }
        if (this.$guid()) {
            if (window.requestIdleCallback) {
                window.requestIdleCallback(sess, { timeout: 600 })
            } else {
                setTimeout(sess, 600)
            }
        }
    },
    destroyed () {
        if (this.worker) {
            this.worker.removeEventListener('message', this.workerMethod)
            this.worker.terminate()
        }
    },
    mounted () {
        gtag('config', settings.gtag, { page_path: '/home' })
        this.$root.$on('loadNews', () => {
            this.updateNews()
        })
        this.$root.$on('startUpload', (idx) => {
            this.startUploadGroup(idx)
        })
        this.$root.$on('stopUpload', (idx) => {
            this.cancelUpload(idx, ' ユーザによってキャンセルされた')
        })
        window.addEventListener('focus', () => {
            if (Date.now() - this.lastUpdate > settings.nextFocusUpdate) {
                this.$http.get('session').then(response => {
                    if (response) {
                        this.store.setNoShare(response.data.user.group.special)
                        this.$root.$emit('updateTable')
                        this.updateNews()
                        this.lastUpdate = Date.now()
                    }
                }).catch(error => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            this.$ls.remove('token')
                            this.store.setUser(null)
                            location.reload()
                        } else {
                            if (error.response.data && error.response.data.error) {
                                this.$snotify.error(error.response.data.error)
                            } else {
                                this.$snotify.error('サーバーエラー')
                            }
                        }
                    }
                })
            }
        })
        if (this.loggedIn) {
            this.updateNews()
            this.populateTeams()
        }
    },
    methods: {
        getCookie (name) {
            let cookieValue = null
            if (document.cookie && document.cookie !== '') {
                const cookies = document.cookie.split(';')
                for (let i = 0; i < cookies.length; i++) {
                    const cookie = cookies[i].trim()
                    // Does this cookie string begin with the name we want?
                    if (cookie.substring(0, name.length + 1) === (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
                        break
                    }
                }
            }
            return cookieValue
        },
        workerMethod (event) {
            if (typeof event.data === 'object') {
                const vid = event.data.vid
                const idx = event.data.idx
                if ('hash' in event.data) {
                    const hash = event.data.hash
                    this.$root.$emit('wake', false)
                    this.$http.post('video/' + vid + '?oper=hash', { hash }).then(response => {
                        if (response && response.data.exists) {
                            const group = this.uploadGroups[idx]
                            for (let i = 0; i < group.uploads.length; i++) {
                                group.uploads[i].uploaded = true
                                group.uploads[i].progress = 100
                                this.store.updateUpload(idx, i, {
                                    uploaded: true,
                                    progress: 100
                                })
                            }
                            this.store.updateUploadGroup(idx, {
                                hash,
                                uploaded: true,
                                progress: 100,
                                finished: group.uploads.length
                            })
                            this.$root.$emit('updateTable')
                            this.uploadNext()
                        } else {
                            this.store.setUploadGroup(idx, 'hash', hash)
                            if (this.uploadGroups.filter((v) => v.uploading).length < 2) {
                                this.startUploadGroup(idx)
                            }
                        }
                    }).catch((error) => {
                        if (error.response) {
                            if (error.response.data && error.response.data.error) {
                                this.$snotify.error(error.response.data.error)
                            } else {
                                this.$snotify.error('サーバーエラー')
                            }
                        }
                    })
                } else if ('percent' in event.data) {
                    window.requestAnimationFrame(() => {
                        this.store.setUploadGroup(idx, 'process', Math.ceil(event.data.percent * 100))
                    })
                } else {
                    this.$root.$emit('wake', false)
                    // even when hashing error, I think we should upload the file anyway
                    this.store.setUploadGroup(idx, 'hash    ', 'error')
                    if (this.uploadGroups.filter((v) => v.uploading).length < 2) {
                        this.startUploadGroup(idx)
                    }
                    if (event.data instanceof Error) {
                        this.$snotify.error(event.data.message, 'アップロード準備エラー')
                        // eslint-disable-next-line no-undef
                        this.$log('hashError', { event_label: 'vid: ' + vid + ' -- ' + event.data.message })
                    }
                    console.log(typeof event.data, event.data)
                }
            }
        },
        /**
         * Update news
         */
        updateNews () {
            this.$http.get('news/latest', {
                params: {
                    group: this.$ls.get('news-g', 0),
                    system: this.$ls.get('news-s', 0)
                }
            }).then((response) => {
                if (response) {
                    this.$root.$emit('updateNews', response.data.news)
                }
            }).catch((error) => {
                if (error.response) {
                    if (error.response.data && error.response.data.error) {
                        this.$snotify.error(error.response.data.error)
                    } else {
                        this.$snotify.error('サーバーエラー')
                    }
                }
            })
        },
        /**
         * Get video Url for play
         * @param video Video object from server
         * @param cb Callback
         */
        getPlayURL (video, cb) {
            if (video.status !== 'ready' || video.archived) {
                return
            }

            this.$root.$emit('loading', true)
            this.$http.get('url/play/' + video.video_id).then((response) => {
                if (response) {
                    if (typeof cb === 'function') {
                        cb(response.data.url)
                    }
                }
            }).catch((error) => {
                if (error.response) {
                    if (error.response.data && error.response.data.error) {
                        this.$snotify.error(error.response.data.error)
                    } else {
                        this.$snotify.error('サーバーエラー')
                    }
                }
            }).finally(() => {
                this.$root.$emit('loading', false)
            })
        },
        /**
         * Create one time url
         **/
        createOneTimeURL (selectedItem) {
            if (selectedItem) {
                const row = this.phone ? 2 : 1
                this.$root.$emit('loading', true)
                this.$http.get('url/query/' + selectedItem.video_id).then(response => {
                    this.$swal({
                        title: 'ダウンロード専用URL',
                        html: '<div>残り作成上限：<span>' + response.data.count + '</span> / <span>' + response.data.limit + '</span><br>新しいDL専用URLを作成しますか？</div>',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#ed9d2b',
                        cancelButtonText: 'キャンセル',
                        confirmButtonText: '続行'
                    }).then((result) => {
                        if (result.value) {
                            this.$root.$emit('loading', true)
                            this.$http.get('url/onetime/' + selectedItem.video_id).then((response) => {
                                const url = location.protocol + '//' + location.host + '/#/download/' + response.data.hash
                                this.$swal({
                                    title: 'ダウンロード専用URL',
                                    type: 'info',
                                    html: '<div class="form-group"><textarea id="dlurl" class="form-control text-center" rows="' + row +
                                        '" style="display:block; height:auto; resize: none;" readonly>' + url + '</textarea></div>' +
                                        '<div class="small">作成上限：<span>' + response.data.count + '</span> / <span>' + response.data.limit + '</span><br>' +
                                        response.data.expire + 'までに有効</div>'
                                })
                                document.querySelector('#dlurl').addEventListener('click', evt => {
                                    navigator.clipboard.writeText(evt.target.value).then(() => {
                                        this.$swal.showValidationMessage('ダウンロード専用URLをクリップボードにコピーしました')
                                        setTimeout(() => {
                                            this.$swal.resetValidationMessage()
                                        }, 3000)
                                    })
                                })
                                /* eslint-disable no-undef */
                                this.$log('share', { method: selectedItem.name })
                            }).catch((error) => {
                                if (error.response) {
                                    switch (error.response.status) {
                                    case 404:
                                        this.$snotify.error('指定した映像が存在しない')
                                        break
                                    case 403:
                                        this.$snotify.error('作成する数の上限が越えました')
                                        break
                                    default:
                                        if (error.response.data && error.response.data.error) {
                                            this.$snotify.error(error.response.data.error)
                                        } else {
                                            this.$snotify.error('サーバーエラー')
                                        }
                                        break
                                    }
                                }
                            }).finally(() => {
                                this.$root.$emit('loading', false)
                            })
                        }
                    })
                }).catch(error => {
                    if (error.response) {
                        switch (error.response.status) {
                        case 404:
                            this.$snotify.error('指定した映像が存在しない')
                            break
                        case 403:
                            this.$snotify.error('作成する数の上限が越えました')
                            break
                        default:
                            if (error.response.data && error.response.data.error) {
                                this.$snotify.error(error.response.data.error)
                            } else {
                                this.$snotify.error('サーバーエラー')
                            }
                            break
                        }
                    }
                }).finally(() => {
                    this.$root.$emit('loading', false)
                })
            }
        },
        /**
         * Archive selected video
         */
        archiveVideo (selectedItem, force) {
            if (selectedItem) {
                if (!force && selectedItem.status === 'ready') {
                    const acl = selectedItem.acl.filter(value => value.streaming).map(value => value.group_id).filter(value => value !== selectedItem.group_id)
                    if (acl.length) {
                        this.$swal({
                            title: '映像公開中',
                            text: 'この映像が他チームに公開している。そのまま続行しますか？',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#ed9d2b',
                            cancelButtonText: 'キャンセル',
                            confirmButtonText: '続行'
                        }).then((result) => {
                            if (result.value) {
                                this.archiveVideo(selectedItem, true)
                            }
                        })
                        return
                    }
                }
                this.$swal({
                    title: '映像アーカイブ',
                    html: `「${selectedItem.name}」をアーカイブしますか？<br>以下の空欄に「archive」を入力して、アーカイブボタンをクリックしてください`,
                    input: 'text',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d9534f',
                    cancelButtonText: 'キャンセル',
                    confirmButtonText: 'アーカイブ',
                    inputValidator: (value) => {
                        if (!value || value !== 'archive') {
                            return '空欄に「archive」を入力してください'
                        }
                    }
                }).then((result) => {
                    if (result.value) {
                        this.$root.$emit('closeInfoModal')
                        this.$root.$emit('loading', true)
                        this.$http.post('video/' + selectedItem.video_id + '?oper=archive').then((response) => {
                            if (response) {
                                this.$root.$emit('updateTable')
                                this.$snotify.success('「' + selectedItem.name + '」がアーカイブされました。')
                                this.$log('archive', { vid: selectedItem.video_id })
                            }
                        }).catch((error) => {
                            if (error.response) {
                                switch (error.response.status) {
                                case 404:
                                    this.$snotify.error('指定した映像が存在しない')
                                    break
                                case 403:
                                    this.$snotify.error('アーカイブする権限がありません')
                                    break
                                default:
                                    if (error.response.data && error.response.data.error) {
                                        this.$snotify.error(error.response.data.error)
                                    } else {
                                        this.$snotify.error('サーバーエラー')
                                    }
                                    break
                                }
                            }
                        }).finally(() => {
                            this.$root.$emit('loading', false)
                        })
                    }
                })
            }
        },
        /**
         * Archive selected video (for manager)
         */
        restoreVideo (selectedItem) {
            this.$http.get('group/restore').then(response => {
                if (response) {
                    if (response.data.active >= response.data.max_active + 5) {
                        this.$snotify.error('アクティブ映像が上限（' + response.data.max_active + '）を越えました、古い映像をアーカイブしてください')
                        return
                    }
                    if (response.data.max - response.data.count < 1) {
                        this.$snotify.error('復元可能数が越えました')
                        return
                    }
                    this.$swal({
                        title: '映像復元',
                        html: `「${selectedItem.name}」を復元しますか？（復元数：${response.data.count}/${response.data.max}）<br>以下の空欄に「restore」を入力して、復元ボタンをクリックしてください。`,
                        input: 'text',
                        type: 'warning',
                        showCancelButton: true,
                        cancelButtonText: 'キャンセル',
                        confirmButtonText: '復元',
                        inputValidator: (value) => {
                            if (!value || value !== 'restore') {
                                return '空欄に「restore」を入力してください'
                            }
                        }
                    }).then((result) => {
                        if (result.value) {
                            this.restore(selectedItem)
                        }
                    })
                }
            }).catch(error => {
                if (error.response) {
                    if (error.response.data && error.response.data.error) {
                        this.$snotify.error(error.response.data.error)
                    } else {
                        this.$snotify.error('サーバーエラー')
                    }
                }
            })
        },
        /**
         * Restore selected video
         */
        restore (selectedItem) {
            if (selectedItem) {
                this.$root.$emit('loading', true)
                this.$http.post('video/' + selectedItem.video_id + '?oper=restore').then((response) => {
                    if (response) {
                        this.$root.$emit('closeInfoModal')
                        this.$root.$emit('updateTable')
                        this.$log('restore', { vid: selectedItem.video_id })
                    }
                }).catch((error) => {
                    if (error.response) {
                        switch (error.response.status) {
                        case 404:
                            this.$snotify.error('指定した映像が存在しない')
                            break
                        case 403:
                            this.$snotify.error('復元する権限がありません')
                            break
                        default:
                            if (error.response.data && error.response.data.error) {
                                this.$snotify.error(error.response.data.error)
                            } else {
                                this.$snotify.error('サーバーエラー')
                            }
                            break
                        }
                    }
                }).finally(() => {
                    this.$root.$emit('loading', false)
                })
            }
        },
        /**
         * Delete selected video
         */
        deleteVideo (selectedItem, force) {
            if (selectedItem) {
                if (!force && selectedItem.status === 'ready') {
                    const acl = selectedItem.acl.filter(value => value.streaming).map(value => value.group_id).filter(value => value !== selectedItem.group_id)
                    if (acl.length) {
                        this.$swal({
                            title: '映像公開中',
                            text: 'この映像が他チームに公開している。そのまま続行しますか？',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#ed9d2b',
                            cancelButtonText: 'キャンセル',
                            confirmButtonText: '続行'
                        }).then((result) => {
                            if (result.value) {
                                this.deleteVideo(selectedItem, true)
                            }
                        })
                        return
                    }
                }
                this.$swal({
                    title: '映像削除',
                    html: `「${selectedItem.name}」を削除しますか？<br>以下の空欄に「delete」を入力して、削除ボタンをクリックしてください`,
                    input: 'text',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d9534f',
                    cancelButtonText: 'キャンセル',
                    confirmButtonText: '削除',
                    inputValidator: (value) => {
                        if (!value || value !== 'delete') {
                            return '空欄に「delete」を入力してください'
                        }
                    }
                }).then((result) => {
                    if (result.value) {
                        let wait = 0
                        const uIdx = this.uploadGroups.findIndex((v) => v.vid === selectedItem.video_id)
                        if (uIdx > -1) {
                            this.cancelUpload(uIdx, '削除されました')
                            wait = 1000
                        }
                        this.$root.$emit('closeInfoModal')
                        setTimeout(() => {
                            this.$http.delete('video/' + selectedItem.video_id).then(() => {
                                this.$root.$emit('updateTable')
                                this.$snotify.success('「' + selectedItem.name + '」が削除されました。') // TODO
                                setTimeout(() => {
                                    this.uploadGroups.splice(uIdx, 1)
                                }, wait)
                                this.$log('delete', { vid: selectedItem.video_id })
                            }).catch((error) => {
                                if (error.response) {
                                    switch (error.response.status) {
                                    case 404:
                                        this.$snotify.error('指定した映像が存在しない')
                                        break
                                    case 403:
                                        this.$snotify.error('削除する権限がありません')
                                        break
                                    default:
                                        if (error.response.data && error.response.data.error) {
                                            this.$snotify.error(error.response.data.error)
                                        } else {
                                            this.$snotify.error('サーバーエラー')
                                        }
                                        break
                                    }
                                }
                            })
                        }, wait)
                    }
                })
            }
        },
        /**
         * Update upload status
         * @param idx
         * @param uploadId
         * @param status
         */
        updateUpload (idx, uploadId, status) {
            const group = this.uploadGroups[idx]
            if (!group) {
                return
            }
            const uIdx = group.uploads.findIndex((v) => v.uploadId === uploadId)
            this.$http.post('upload/' + uploadId, {
                status
            }).then((response) => {
                if (response) {
                    switch (status) {
                    case 'up_end':
                        if (response.data.video) {
                            this.store.updateUploadGroup(idx, {
                                progress: 100,
                                uploaded: true,
                                uploading: false,
                                error: false
                            })
                            this.$root.$emit('updateTable')
                            this.$snotify.success('「' + response.data.video.name + '」のアップロードが成功しました。サーバーでの処理しています、しばらくお待ちください。') // TODO
                            this.uploadNext()
                        } else {
                            this.startUploadGroup(idx)
                        }
                        break
                    case 'up':
                        if (uIdx > -1 && group.uploads[uIdx].chunk === 1) {
                            this.$root.$emit('updateTable')
                        }
                        break
                    case 'up_err':
                        this.$root.$emit('updateTable')
                        break
                    default:
                        // TODO: tokuni nashi
                        break
                    }
                }
            }).catch((error) => {
                if (uIdx > -1) {
                    this.updateUpload(idx, uIdx, {
                        error: true,
                        uploading: false,
                        msg: error.message
                    })
                }
                this.store.updateUploadGroup(idx, {
                    error: true,
                    uploading: false,
                    msg: error.message
                })
                this.uploadNext()
                this.$root.$emit('updateTable')

                if (error.response) {
                    if (error.response.data && error.response.data.error) {
                        this.$snotify.error(error.response.data.error)
                    } else {
                        this.$snotify.error('サーバーエラー')
                    }
                }
            })
        },
        /**
         * Init upload process
         */
        startUploadGroup (idx) {
            console.log('Start', idx)

            if (idx >= this.uploadGroups.length) {
                return
            }
            const group = this.uploadGroups[idx]
            if (!group.hash) {
                return
            }

            const vid = group.vid
            for (let i = 0; i < group.uploads.length; i++) {
                const u = group.uploads[i]
                if (u.uploaded) {
                    continue
                }
                if (u.uploading) {
                    break
                }
                let uploadId = u.uploadId

                this.$http.post('upload/' + uploadId, {
                    status: 'init',
                    filename: u.name,
                    size: u.file.size,
                    chunk: u.chunk,
                    chunks: u.chunks,
                    vid
                }).then((response) => {
                    console.log(JSON.stringify(response.data.post, null, 2))
                    const url = response.data.post.url
                    const fields = response.data.post.fields
                    const totalSize = group.uploads.reduce((previousValue, currentValue) => previousValue + currentValue.file.size, 0)
                    let uploadedSize = group.uploads.filter((v) => v.uploaded).reduce((previousValue, currentValue) => previousValue + currentValue.file.size, 0)
                    console.log('totalSize', totalSize)
                    console.log('uploadedSize', uploadedSize)
                    uploadId = uploadId || response.data.upload.upload_id
                    this.store.updateUpload(idx, i, {
                        uploadId,
                        error: false,
                        msg: '',
                        path: response.data.upload.path,
                        uploading: true
                    })
                    this.store.updateUploadGroup(idx, {
                        error: false,
                        msg: '',
                        uploading: true
                    })

                    const cancelToken = axios.CancelToken
                    this.store.setUploadGroup(idx, 'source', cancelToken.source())
                    const csrftoken = this.getCookie('csrftoken')
                    let instance
                    if (response.data.put) {
                        instance = axios.create({
                            cancelToken: group.source.token,
                            onUploadProgress: (progressEvent) => {
                                this.$parent.uploading = true
                                const v = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                                if (v % 2 === 0) {
                                    this.store.updateUpload(idx, i, { progress: v })
                                    this.store.setUploadGroup(idx, 'progress', group.total === 1 ? v : Math.round(((uploadedSize + progressEvent.loaded) * 100) / totalSize))
                                }
                            }
                        })
                    } else {
                        instance = axios.create({
                            cancelToken: group.source.token,
                            headers: {},
                            __noAuth: true,
                            onUploadProgress: (progressEvent) => {
                                this.$parent.uploading = true
                                const v = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                                if (v % 2 === 0) {
                                    this.store.updateUpload(idx, i, { progress: v })
                                    this.store.setUploadGroup(idx, 'progress', group.total === 1 ? v : Math.round(((uploadedSize + progressEvent.loaded) * 100) / totalSize))
                                }
                            }
                        })
                    }

                    this.updateUpload(idx, uploadId, 'up')
                    if (response.data.put) {
                        instance.put(response.data.put, u.file).then(() => {
                            this.store.updateUpload(idx, i, {
                                uploading: false,
                                uploaded: true,
                                progress: 100
                            })
                            const finished = group.uploads.filter((v) => v.uploaded)
                            if (group.total > 1) {
                                uploadedSize = finished.reduce((previousValue, currentValue) => previousValue + currentValue.file.size, 0)
                                this.store.setUploadGroup(idx, 'progress', Math.round(((uploadedSize) * 100) / totalSize))
                            }
                            this.store.updateUploadGroup(idx, {
                                source: null,
                                finished: finished.length
                            })
                            this.updateUpload(idx, uploadId, 'up_end')
                            /* eslint-disable no-undef */
                            this.$log('uploadEnd', { event_label: uploadId })
                        }).catch((error) => {
                            this.store.updateUpload(idx, i, {
                                uploading: false,
                                error: true,
                                msg: error.message
                            })
                            this.store.updateUploadGroup(idx, {
                                error: true,
                                msg: error.message,
                                uploading: false
                            })
                            this.updateUpload(idx, uploadId, 'up_err')
                            if (error.response) {
                                if (error.response.data && error.response.data.error) {
                                    this.$snotify.error(error.response.data.error)
                                } else {
                                    this.$snotify.error('サーバーエラー')
                                }
                            }
                            console.log(error)
                            /* eslint-disable no-undef */
                            this.$log('uploadError', { event_label: 'upid: ' + uploadId + ' -- ' + error.message })
                        })
                    } else {
                        const formData = new FormData()
                        Object.keys(fields).forEach((key) => {
                            formData.append(key, fields[key])
                        })
                        formData.append('file', u.file)
                        console.log('url', url)
                        instance.post(url, formData).then(() => {
                            this.store.updateUpload(idx, i, {
                                uploading: false,
                                uploaded: true,
                                progress: 100
                            })
                            const finished = group.uploads.filter((v) => v.uploaded)
                            if (group.total > 1) {
                                uploadedSize = finished.reduce((previousValue, currentValue) => previousValue + currentValue.file.size, 0)
                                this.store.setUploadGroup(idx, 'progress', Math.round(((uploadedSize) * 100) / totalSize))
                            }
                            this.store.updateUploadGroup(idx, {
                                finished: finished.length,
                                source: null
                            })
                            this.updateUpload(idx, uploadId, 'up_end')
                            /* eslint-disable no-undef */
                            this.$log('uploadEnd', { event_label: uploadId })
                        }).catch((error) => {
                            this.store.updateUpload(idx, i, {
                                uploading: false,
                                error: true,
                                msg: error.message
                            })
                            this.store.updateUploadGroup(idx, {
                                uploading: false,
                                error: true,
                                msg: error.message
                            })
                            this.updateUpload(idx, uploadId, 'up_err')
                            if (error.response) {
                                if (error.response.data && error.response.data.error) {
                                    this.$snotify.error(error.response.data.error)
                                } else {
                                    this.$snotify.error('サーバーエラー')
                                }
                            }
                            console.log(error)
                            /* eslint-disable no-undef */
                            this.$log('uploadError', { event_label: 'upid: ' + uploadId + ' -- ' + error.message })
                        })
                    }
                }).catch((error) => {
                    this.store.updateUploadGroup(idx, {
                        uploading: false,
                        error: true,
                        msg: error.message
                    })
                    this.store.updateUpload(idx, i, {
                        uploading: false,
                        error: true,
                        msg: error.message
                    })
                    if (uploadId) {
                        this.updateUpload(idx, uploadId, 'up_err')
                    }
                    if (error.response) {
                        if (error.response.data && error.response.data.error) {
                            this.$snotify.error(error.response.data.error)
                        } else {
                            this.$snotify.error('サーバーエラー')
                        }
                    }
                    console.log(error)
                    /* eslint-disable no-undef */
                    this.$log('uploadError', { event_label: 'vid: ' + vid + ' -- ' + error.message })
                })
                break
            }
        },
        /**
         * Upload next group
         */
        uploadNext () {
            if (this.uploadGroups.filter((v) => v.uploading).length < 2) {
                const initIdx = this.uploadGroups.findIndex((v) => v.hash && !v.uploading && !v.uploaded && !v.error)
                console.log('next idx: ' + initIdx)
                if (initIdx > -1) {
                    this.startUploadGroup(initIdx)
                }
            }
        },
        /**
         * Cancel upload
         */
        cancelUpload (idx, msg) {
            if (this.uploadGroups.length > idx) {
                if (this.uploadGroups[idx].source) {
                    this.uploadGroups[idx].source.cancel(msg)
                }
                this.store.updateUploadGroup(idx, {
                    uploading: false,
                    uploaded: false,
                    error: true,
                    msg
                })
                this.uploadNext()
            }
        },
        startUpload (name, vid, uploads) {
            this.store.addUploadGroup({
                name,
                vid,
                total: uploads.length,
                finished: 0,
                progress: 0,
                uploaded: false,
                uploading: false,
                error: false,
                msg: '',
                hash: null,
                process: 0,
                uploads
            })
            // let ext = uploads[0].name.toLowerCase().split('.').pop();
            const l = this.uploadGroups.length
            const idx = l - 1
            // changed 2022-03-11 hash all file
            this.$root.$emit('wake', true)
            this.worker.postMessage({
                idx,
                vid,
                files: uploads.map(v => v.file)
            })
        },
        populateTeams () {
            this.$http.get('group/').then((r) => {
                if (r) {
                    this.teams = r.data.groups
                    this.store.setGroups(r.data.groups)
                }
            }).catch((error) => {
                if (error.response) {
                    if (error.response.data && error.response.data.error) {
                        this.$snotify.error(error.response.data.error)
                    } else {
                        this.$snotify.error('サーバーエラー')
                    }
                } else if (error.request) {
                    console.log(error.request)
                } else {
                    console.log(error.config)
                }
                this.$ab?.notify(error)
            })
        }
    }
}
</script>

<style>
.playbutton {
    position: absolute;
    width: 64px;
    height: 64px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}

.thumbLarge {
    position: relative;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 100%;
    padding-bottom: 62.5%;
}

img.thumb {
    width: 80px;
    height: 60px;
}
</style>
